import react, { useState, useEffect } from "react";
import WebAlert from "./WebAlert";
import GuideDashboardHeader from "./GuideDashboardHeader";
import Footer from "./Footer";
import SocialLinksIcon from "./SocialLinkIcon";

const API_URL = process.env.REACT_APP_API_URL || "https://the-boggler-api-96bc2fa97f2d.herokuapp.com/api";

const Phone = (props) => {

    const [showWebAlert, setShowWebAlert] = useState({
        show: false,
        title: "",
        message: "",
        action: null
    });

    const [timeFrame, setTimeFrame] = useState("today");
    const [notes, setNotes] = useState([]);
    const [todayNotes, setTodayNotes] = useState([]);
    const [tomorrowNotes, setTomorrowNotes] = useState([]);
    const [next7DaysNotes, setNext7DaysNotes] = useState([]);
    const [skipNumbers, setSkipNumbers] = useState({ today: 0, tomorrow: 0, next7days: 0 });
    const [prevSkipNumbers, setPrevSkipNumbers] = useState({ today: -1, tomorrow: -1, next7days: -1 });

    const fetchNotes = async (frame = timeFrame, skipNumber = 0) => {
        const prevSkip = prevSkipNumbers[frame];
        if (skipNumber === prevSkip && prevSkip !== -1) return;

        const response = await fetch(`${API_URL}/guide/needs-reply`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${window.localStorage.getItem('guideToken')}`
            },
            body: JSON.stringify({ timeFrame: frame, skipNumber })
        });
        const data = await response.json();
        if (data.success && data.notes && data.notes.length > 0) {
            const newNotes = data.notes;
            if (frame === "today") {
                const merged = skipNumber === 0 ? newNotes : [...todayNotes, ...newNotes];
                setTodayNotes(merged);
                setNotes(merged);
                setSkipNumbers(prev => ({ ...prev, today: merged.length }));
                setPrevSkipNumbers(prev => ({ ...prev, today: skipNumber }));
            } else if (frame === "tomorrow") {
                const merged = skipNumber === 0 ? newNotes : [...tomorrowNotes, ...newNotes];
                setTomorrowNotes(merged);
                setNotes(merged);
                setSkipNumbers(prev => ({ ...prev, tomorrow: merged.length }));
                setPrevSkipNumbers(prev => ({ ...prev, tomorrow: skipNumber }));
            } else if (frame === "next7days") {
                const merged = skipNumber === 0 ? newNotes : [...next7DaysNotes, ...newNotes];
                setNext7DaysNotes(merged);
                setNotes(merged);
                setSkipNumbers(prev => ({ ...prev, next7days: merged.length }));
                setPrevSkipNumbers(prev => ({ ...prev, next7days: skipNumber }));
            }
        } else {
            if (frame === "today") setNotes(skipNumber === 0 ? [] : todayNotes);
            else if (frame === "tomorrow") setNotes(skipNumber === 0 ? [] : tomorrowNotes);
            else setNotes(skipNumber === 0 ? [] : next7DaysNotes);
        }
    };

    useEffect(() => {
        fetchNotes("today", 0);
    }, []);

    const handleSegmentSelect = (frame) => {
        setTimeFrame(frame);
        const skip = skipNumbers[frame] || 0;
        if (frame === "today") setNotes(todayNotes);
        else if (frame === "tomorrow") setNotes(tomorrowNotes);
        else setNotes(next7DaysNotes);
        fetchNotes(frame, skip);
    };

    const callOnWhatsApp = (note) => {
        const customerName = note.customerName || "your customer";
        const phone = (note.customer_phone_number || "").replace(/[^0-9]/g, "");
        setShowWebAlert({
            show: true,
            title: "Call on WhatsApp",
            message: `Call ${customerName} on WhatsApp. Please ensure you are in a quiet environment.`,
            action: phone ? () => window.open(`https://wa.me/${phone}`, '_blank') : null
        });
    };

    return (
        <>
            {showWebAlert?.show && <WebAlert
                isOpen={showWebAlert?.show}
                title={showWebAlert.title}
                message={showWebAlert.message}
                setShowWebAlert={setShowWebAlert}
                action={showWebAlert.action}
            />}
            <GuideDashboardHeader />
            <section className="main-body-section">
                <h2 className="guide-title">Phone</h2>
                <div className="tab-segment">
                    <button className={`tab-button ${timeFrame === "today" ? "selected" : ""}`} onClick={() => handleSegmentSelect("today")}>
                        Today
                    </button>
                    <button className={`tab-button ${timeFrame === "tomorrow" ? "selected" : ""}`} onClick={() => handleSegmentSelect("tomorrow")}>
                        Tomorrow
                    </button>
                    <button className={`tab-button ${timeFrame === "next7days" ? "selected" : ""}`} onClick={() => handleSegmentSelect("next7days")}>
                        Next 7 Days
                    </button>
                </div>
                {notes.length === 0 && (
                    <div className="call-item-card">
                        <div style={{ textAlign: "center" }}><p>No customer notes found.</p></div>
                    </div>
                )}
                <div className="scheduled-calls-list">
                    {notes.map((note) => {
                        const timestamp = note?.callTimePreferenceOfCustomer?.dateTimeUniversalExact;
                        const date = new Date(timestamp);
                        const formattedCallDateTime = timestamp ? date.toLocaleString('en-US', {
                            weekday: 'short',
                            month: 'short',
                            day: '2-digit',
                            hour: 'numeric',
                            minute: '2-digit',
                            timeZoneName: 'short'
                        }) : "No time specified";
                        return (
                            <div key={note._id} className="scheduled-call-item">
                                <div className="call-item-card">
                                    <div className="call-item-header">
                                        <div>
                                            <img src={note.profilePictureUrl} alt="Profile" className="call-item-profile-picture" />
                                            <h3>{note.customerName}</h3>
                                        </div>
                                        <div>
                                            <span style={{ fontWeight: "bold", fontSize: "20px" }}>{formattedCallDateTime}</span>
                                        </div>
                                    </div>
                                    {note.customerSocialLinks && note.customerSocialLinks.length > 0 && (
                                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", margin: "8px 0" }}>
                                            {note.customerSocialLinks.map((link, i) => (
                                                <SocialLinksIcon key={i} platform={link.platform} onClick={() => window.open(link.url, "_blank")} />
                                            ))}
                                        </div>
                                    )}
                                    <p className="lucky-font" style={{ fontWeight: "bold", fontSize: "22px", whiteSpace: "pre-wrap" }}>{note.message}</p>
                                    <div className="phone-call-action-items-container">
                                        <button onClick={() => callOnWhatsApp(note)} className="phone-call-action-button make-call-button">
                                            Call on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {notes.length >= 10 && (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <button className="load-more-button" onClick={() => fetchNotes(timeFrame, skipNumbers[timeFrame])}>Load More</button>
                    </div>
                )}
            </section>
            <Footer />
        </>
    );
}

export default Phone;